import { render, staticRenderFns } from "./Additional.vue?vue&type=template&id=0fda867f&scoped=true&"
import script from "./Additional.vue?vue&type=script&lang=ts&"
export * from "./Additional.vue?vue&type=script&lang=ts&"
import style0 from "./Additional.vue?vue&type=style&index=0&id=0fda867f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fda867f",
  null
  
)

export default component.exports